import React, { Fragment } from "react";
//Map import
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "./Map.css";

export default function DumpsterLocation() {

    const center = [40.753519, -8.572765];

    const map = (
        <div id="mapContainer">
            <MapContainer className="map" center={center} zoom={17}>
                <TileLayer
                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}.png"
                    maxZoom="18"
                    attribution=''
                />
                <Fragment>
                    <Marker position={center}>
                        <Popup >ESTA Villa Residence <br></br> R. Des. Correia Teles - Estarreja <br></br> 40.753519, -8.572765</Popup>
                    </Marker>
                </Fragment>
            </MapContainer></div>
    );
    return map;
}

/*


*/
